define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/util',
    'd3'
], function(
    SVGView,
    SVGUtil,
    d3
    ) {
    /**
     * @exports views/diagram/mark/mark
     */
    const symbols = {
        circle: d3.symbolCircle,
        triangle: d3.symbolTriangle,
        diamond: d3.symbolDiamond,
        cross: d3.symbolCross
    };

    var Mark = SVGView.extend({
        /**
         * @lends module:views/diagram/mark/mark.Mark.prototype
         */
        className: 'mark',
        defaultSize: 800,
        defaultWidth: 50,
        defaultHeight: 50,

        /**
         * Link のマーク
         *
         * @constructs
         */
        initialize: function(params) {
            Mark.__super__.initialize.call(this, params);
            this.params = params;
            this.type = params.type;
            // size は面積に比例するので 2 乗しておく
            this.size = params.size ? (params.size * params.size) * this.defaultSize : this.defaultSize;
            this._width = params.size ? params.size * this.defaultWidth : this.defaultWidth;
            this._height = params.size ? params.size * this.defaultWidth : this.defaultWidth;
            this._offset = _.extend({
                x: 0,
                y: 0
            }, params.offset);
        },

        height: function() {
            return this._height;
        },

        width: function() {
            return this._width;
        },

        offset: function() {
            return this._offset;
        },

        render: function() {
            if(this.params.circle) {
                this.$el.append('circle')
                    .classed('mark-bg', true)
                    .attr('r', this.size / this.defaultSize * 30)
            }

            this.$el.append('path')
                .classed('mark-shape', true)
                .attr('d', d3.symbol()
                    .type(symbols[this.type])
                    .size(this.size))
                .attr('transform', SVGUtil.transform(this.offset()));

            this.updateStyles(this.params.style);

            return this;
        }
    });

    return Mark;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/mark/index.js